import {
  faNoteSticky,
  faCalendar,
  faSearch,
  faLeftRight,
  faChartLine,
  faReceipt,
  faLock,
  faGear,
  faArrowsUpDown,
  faDollar,
  faBriefcase,
  faGamepad
} from "@fortawesome/free-solid-svg-icons";
import SellIcon from "../images/sell.png";
import buysell from "../images/buysell.png";
import { SUBSCRIPTION_ENABLED } from "../utils/utils";
import { path } from "react-financial-charts";
import { IconHandDollar, IconSentiment ,TrendingStore} from "../icons/icons";
//console.log(SUBSCRIPTION_ENABLED, "aaaaaaaaaaaaaaaa");

const initMenu = [
  {
    label: "Home",
    path: "/feed",
    icon: faCalendar,
  },
  {
    label: "Watchlist",
    path: "/search",
    icon: faSearch,
  },
  {
    label: "Buy / Sell",
    path: "/buysell",
    icon: buysell,
  },
  {
    label: "Charts",
    path: "/charts",
    icon: faChartLine,
  },
  {
    label: "Portfolio",
    path: "/portfolio",
    icon: faBriefcase,
  },
  // {
  //   label: "Cliff Notes",
  //   path: "/cliff-notes",
  //   icon: faNoteSticky,
  // },
  {
    label: "Add",
    path: "/create-post",
    icon: faReceipt,
  },
  {
    label: "Market Sentiment",
    path: "/market-sentiment",
    // icon: faChartLine,
    iconCustom: IconSentiment,
  },
    {
    label: "Today’s Movers",
    path:"/auth/trending-stocks",
    // icon: faGamepad
    iconCustom: TrendingStore
  },

  {
    label: "League Play",
    path:"/contest",
    // icon: faGamepad
    iconCustom: IconHandDollar
  },
  {
    label: "Settings",
    path: "/settings",
    icon: faGear,
  },
];
if (SUBSCRIPTION_ENABLED) {
  console.log(SUBSCRIPTION_ENABLED, "aaaaaaaaaa");
  initMenu.push({
    label: "Subscriptions",
    path: "/subscriptions",
    icon: faDollar,
  });
}
export default initMenu;
